<template>
  <div class="template-main">
    <header>
      <!-- 左侧LOGO -->
      <nav>
        <div class="icon">
          <img class="logo" src="@/assets/images/logo.png" @click="toICode" />
        </div>
        <div v-for="item in eventInfo.config.topleftIcons" :key="item.id" class="icon">
          <img class="logo" :src="item.src" @click="toHref(item.href)"/>
        </div>
      </nav>
      
      <!-- 导航栏按钮 -->
      <nav>
        <div v-if="eventInfo.i18nBtn" class="changeLangBtn" @click.stop="moreLang()">
          <img class="naviIcon" src="@/assets/images/language.png"/>
          <span class="language">{{ $t("LanguageName") }}</span>
          
          <ul v-show="changeLangBox" class="chooseLangUl">
            <li v-for="(item, index) in langList" :key="index" @click="setLanguage(item.id)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        
        <div v-for="item in eventInfo.toprightLinks" :key="item.name" class="btn navlink">
          <a v-if="item.link" :href="item.link" target="_blank">{{ $t(item.name) }}</a>
          <el-dropdown v-if="item.type == 'dropdown'">
            <a >{{ $t(item.name) }}</a>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="padding: 0; margin:0 ;">
                <img style="width:320px" :src="'https://c.icode.org.cn/contests/meeting/' + item.img"/>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div v-if="eventInfo.testBtn && ($route.name == 'contest_userIndex')" class="btn navlink">
          <a href="#" @click="userInfo.toTestDialogShow = true">{{$t("Device_Test")}}</a>
        </div>

        <div v-if="eventInfo.personalRankMaxPage || eventInfo.schoolRankMaxPage" class="btn navlink">
          <a :href="getRankboardUrl()" target="_blank">{{$t("Rankboard")}}</a>
        </div>
      </nav>
    </header>

    <main>
      <router-view :eventInfo="eventInfo" :userInfo="userInfo" v-if="eventInfo.id"></router-view>
    </main>

  </div>
</template>

<script>
import '@/components/contest/assets/css/template.scss';
import '@/style/contest.scss';

import { parseEventInfo } from '@/components/contest/template/event';
import I18nUtils from '@/utils/i18nUtils';
import { checkCookie } from '@/utils/browserCheck';

export default {
  data() {
    return {
      eventInfo: {
        channel: null,
        config: {
          topleftIcons: [],
        }
      },

      userInfo: {
        userId: undefined,
        toTestDialogShow: false,  // 设备测试

        grade: "",
        age: 0,
        schoolName: "",
        confirmed: false,

        userName:"",
        userScore: 0,

        mobile:"",
        userAccount:"",

        game: undefined,
        gameId: undefined,
        isVip: 0,
        orgId: 0,
        
        teacherName: undefined,
        teacherMobile: undefined,
      },

      langList: I18nUtils.langList,
      changeLangBox: false,
    };

  },

  methods: {
    toHref(href) {
      window.open(href, "_blank");
    },
    toICode() {
      if(this.$route.name == "contest_index") { // 首页
        let mainChannel = this.eventInfo.channel.split("_")[0];
        if(mainChannel !== this.eventInfo.channel) {
          this.$router.push({ path: `/${mainChannel}` });
        }
        return;
      }

      this.$router.push({ path: "/" + this.eventInfo.channel });
    },

    afterEventInfoReady(){
      if(this.eventInfo.i18nBtn) {
        I18nUtils.initLanguage(this);

        // 显示可用的语言列表 ["zh", "en", "zh_Hant"]
        if(this.eventInfo.config) {
          let languages = this.eventInfo.config.languages || ["zh", "en"];
          this.langList = I18nUtils.langList.filter(item => languages.includes(item.id));
        }

      } else {
        I18nUtils.initLanguage(this);
        I18nUtils.setLanguage(this, 'zh'); // 默认为中文
      }
    },

    async getEventInfo(params) {
      try {
        await this.$http
          .getAxios(`event/getEvent`, {
            method: "get",
            params: params,
          })
          .then((res) => {
            const _res = res.data;

            if (_res.code == 0) {
              this.eventInfo = _res.data;
              parseEventInfo(this.eventInfo);
              this.afterEventInfoReady();

            } else {
              this.$notify.error({
                title: this.$t("Event_Not_Ready"),
                message: this.$t("Event_Not_Ready_Message"),
              });
            }

          });
      } catch (e) {
        console.log(e);
      }
    },

    moreLang() {
      this.changeLangBox = !this.changeLangBox;
    },

    setLanguage(lang) {
      I18nUtils.setLanguage(this, lang);
    },

    getRankboardUrl() {
      const ixURL = process.env.GO_IX; // todo: c.icode => ix.icode
      return `${ixURL}rankBoard?eventCode=${this.eventInfo.eventCode}&lang=${this.$i18n.locale}`
    },

  },

  created() {
    let channel = this.$route.params['channel'];
    if(channel != this.eventInfo.channel) {
      this.getEventInfo({channel: channel});
    }
    checkCookie();
    
  },

};
</script>



// WEBPACK FOOTER //
// src/components/contest/template/main.vue